"use client";

import createSvgIcon from "@mui/material/utils/createSvgIcon";
const Google = createSvgIcon(<svg fill="currentColor" viewBox="0 0 14 14">
    <path d="M2.8 7C2.8 9.3196 4.6804 11.2 7 11.2C8.82871 11.2 10.3844 10.0313 10.961 8.4H7V5.6H13.8633V8.4H13.86C13.2114 11.5951 10.3865 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C9.41148 0 11.5382 1.2194 12.7971 3.07522L10.5028 4.6817C9.75071 3.54768 8.46267 2.8 7 2.8C4.6804 2.8 2.8 4.6804 2.8 7Z" fill="white" />
  </svg>, "Google");
export default Google;